<template>
  <div>
    <div class="infos">
      <div class="devices">设备数:{{deviceNum}} </div>
      <el-button type="primary" @click="toLayer" size="mini">前往管理</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      deviceNum: '',
      deviceInfos: ''
    }
  },
  components: {
    
  },
  computed: {
  },
  created () {
    this.deviceNum = sessionStorage.getItem('deviceNum');
    this.deviceInfos = JSON.parse(localStorage.getItem('sRowInfo'))
  },
  methods: {
    toLayer () {
      this.$router.push({
        path: '/deviceManagement/DeviceManager',
        query: {
          productKey: this.deviceInfos.productKey
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
  .infos {
    display: flex;
    align-items: center;
    .devices {
      margin-right: 10px;
    }
  }
</style>
